import 'bootstrap';

import { pricingPage } from './parts/pricing_page';
import { menuBeam } from './parts/menu_beam';

document.addEventListener('DOMContentLoaded', function() {
    pricingPage();
    menuBeam();
});

